import axios from "axios";

const instance = axios.create({
  baseURL: "https://denilgabani.herokuapp.com",
});

export default instance;
